import {PROGRAM_DATA_INDEX, PROGRAM_DATA_LENGTH, ITEM_HEADER_INDEX, ITEM_DATA_LENGTH, MAX_ITEM_COLUMN_VAL} from "src/model/TemplateUploadInputRecord";

export default class FileParser {
    public static parseTxt = (txtFile: File, setData: Function, setError: Function): void => {
        let fileReader = new FileReader();
        fileReader.onloadend = function (e) {
            try {
                const content = e.target?.result ?? null;
                if (content != null) {
                    let fileArray = content.toString().split("\n");
                    let programData: string[] = [];
                    let itemData: string[][] = [];

                    let validRowIndex = 0;

                    for (let i = 0; i < fileArray.length; i++) {
                        let originalRow = fileArray[i];

                        // Mac
                        if (originalRow.endsWith("\r")) {
                            originalRow = originalRow.substring(0, originalRow.length - 1);
                        }

                        // all inputs are blank
                        // this is because we apply restrictions on all 20 rows, so if user don't fill the row, it will return a
                        // row which contains "\t\t\t\t\t\t\t....\t"
                        if (originalRow.replace(/(^\s*)|(\s*$)/g, "").length <= 1) continue;
                        let processedRow = originalRow.split("\t");

                        if (validRowIndex == PROGRAM_DATA_INDEX) {
                            // since row 3 contains 28 columns, here the program data length is also 28.
                            if (processedRow.length < PROGRAM_DATA_LENGTH) {
                                throw new Error("Invalid program data");
                            }
                            programData = processedRow.slice(0, PROGRAM_DATA_LENGTH);
                        } else if (validRowIndex > ITEM_HEADER_INDEX) {
                            if (processedRow.length != ITEM_DATA_LENGTH) {
                                throw new Error("Invalid item data");
                            }
                            itemData.push(processedRow);
                        }

                        validRowIndex += 1;
                        if (validRowIndex >= MAX_ITEM_COLUMN_VAL) break;
                    }

                    if (programData.length == 0 || itemData.length == 0) {
                        throw new Error("Blank program or item data")
                    }
                    setData(programData, itemData);
                }
            } catch (error: any) {
                setError(error.message);
            }
        };
        fileReader.readAsText(txtFile);
    }
}
